<template>
<div class="spackage padding-20 bgc box-shadow">
    <keep-alive include="spackageList">
        <router-view></router-view>        
    </keep-alive>
</div>
</template>

<script>
export default {
    name: 'spackage',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {
    },
    filters: {
    },
    watch: {},
    computed: {
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.spackage {
}
</style>
